// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HowToPlay_containerInfo__gz\\+Ug{
    display: flex;
    justify-content: space-between;
    
    gap:20px;
}
.HowToPlay_containerCircles__--rUE{
    display: flex;
    justify-content: center;
    gap:10px;
}
.HowToPlay_wrapper__vJp9k{
    display: flex;
    flex-direction: column;
    
    background: rgba(17,23,32,.75);
    padding: 10px;
    border-radius: 10px;

}
.HowToPlay_circle__Ft9ti{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    

}
.HowToPlay_circleMini__dN3Iu{
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: rgb(47, 62, 87);
    

}
.HowToPlay_infoBlock__TNttx{
    display: flex;
    justify-content: center ;
    width: 300px;
}
.HowToPlay_buttonChoice__kEJyJ{
    text-align: center;
    font-size: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    color:white;
    width:39px;
    height:39px;
    border-radius: 10px;
    background-color: #293069a6;
    cursor: pointer;
}
.HowToPlay_wrapperButton__M4Qbl{
    display: flex;
    align-items: center;
}
@media screen and (max-width:800px) {
    .HowToPlay_containerInfo__gz\\+Ug{
        gap:0;
    }
    .HowToPlay_infoBlock__TNttx{
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/components/HowToPlay/HowToPlay.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;;IAE9B,QAAQ;AACZ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,sBAAsB;;IAEtB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;;AAEvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;;IAElB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;;;AAGnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;;;AAG/B;AACA;IACI,aAAa;IACb,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI;QACI,KAAK;IACT;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".containerInfo{\n    display: flex;\n    justify-content: space-between;\n    \n    gap:20px;\n}\n.containerCircles{\n    display: flex;\n    justify-content: center;\n    gap:10px;\n}\n.wrapper{\n    display: flex;\n    flex-direction: column;\n    \n    background: rgba(17,23,32,.75);\n    padding: 10px;\n    border-radius: 10px;\n\n}\n.circle{\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    \n\n}\n.circleMini{\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    background: rgb(47, 62, 87);\n    \n\n}\n.infoBlock{\n    display: flex;\n    justify-content: center ;\n    width: 300px;\n}\n.buttonChoice{\n    text-align: center;\n    font-size: 23px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color:white;\n    width:39px;\n    height:39px;\n    border-radius: 10px;\n    background-color: #293069a6;\n    cursor: pointer;\n}\n.wrapperButton{\n    display: flex;\n    align-items: center;\n}\n@media screen and (max-width:800px) {\n    .containerInfo{\n        gap:0;\n    }\n    .infoBlock{\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerInfo": `HowToPlay_containerInfo__gz+Ug`,
	"containerCircles": `HowToPlay_containerCircles__--rUE`,
	"wrapper": `HowToPlay_wrapper__vJp9k`,
	"circle": `HowToPlay_circle__Ft9ti`,
	"circleMini": `HowToPlay_circleMini__dN3Iu`,
	"infoBlock": `HowToPlay_infoBlock__TNttx`,
	"buttonChoice": `HowToPlay_buttonChoice__kEJyJ`,
	"wrapperButton": `HowToPlay_wrapperButton__M4Qbl`
};
export default ___CSS_LOADER_EXPORT___;
